"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5907],{

/***/ 21017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// UNUSED EXPORTS: _Card

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.context.js


const CardContext = (0,react.createContext)({ padding: 0 });
const CardProvider = CardContext.Provider;
const useCardPadding = () => (0,react.useContext)(CardContext).padding;


//# sourceMappingURL=Card.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/CardSection/CardSection.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { padding, withBorder, inheritPadding }) => {
  const spacing = theme.fn.size({ size: padding, sizes: theme.spacing });
  const offset = -1 * spacing;
  const borderColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return {
    cardSection: {
      display: "block",
      marginLeft: offset,
      marginRight: offset,
      paddingLeft: inheritPadding ? spacing : void 0,
      paddingRight: inheritPadding ? spacing : void 0,
      borderTop: withBorder && `1px solid ${borderColor}`,
      borderBottom: withBorder && `1px solid ${borderColor}`,
      "& + &": {
        borderTop: 0
      },
      "&[data-first]": {
        marginTop: offset,
        borderTop: 0,
        borderBottom: withBorder && `1px solid ${borderColor}`
      },
      "&[data-last]": {
        marginBottom: offset,
        borderBottom: 0
      }
    }
  };
});

/* harmony default export */ var CardSection_styles = (useStyles);
//# sourceMappingURL=CardSection.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/CardSection/CardSection.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  withBorder: false,
  inheritPadding: false
};
const _CardSection = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("CardSection", defaultProps, props), { className, withBorder, inheritPadding, unstyled } = _a, others = __objRest(_a, ["className", "withBorder", "inheritPadding", "unstyled"]);
  const { classes, cx } = CardSection_styles({ padding: useCardPadding(), withBorder, inheritPadding }, { name: "Card", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.cardSection, className),
    ref
  }, others));
});
_CardSection.displayName = "@mantine/core/CardSection";
const CardSection = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_CardSection);


//# sourceMappingURL=CardSection.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.styles.js


var Card_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
  }
}));

/* harmony default export */ var Card_styles = (Card_styles_useStyles);
//# sourceMappingURL=Card.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.js








var Card_defProp = Object.defineProperty;
var Card_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Card_hasOwnProp = Object.prototype.hasOwnProperty;
var Card_propIsEnum = Object.prototype.propertyIsEnumerable;
var Card_defNormalProp = (obj, key, value) => key in obj ? Card_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Card_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Card_hasOwnProp.call(b, prop))
      Card_defNormalProp(a, prop, b[prop]);
  if (Card_getOwnPropSymbols)
    for (var prop of Card_getOwnPropSymbols(b)) {
      if (Card_propIsEnum.call(b, prop))
        Card_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Card_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Card_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Card_getOwnPropSymbols)
    for (var prop of Card_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Card_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Card_defaultProps = {
  p: "md"
};
const _Card = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Card", Card_defaultProps, props), { className, p, radius, children, unstyled } = _a, others = Card_objRest(_a, ["className", "p", "radius", "children", "unstyled"]);
  const { classes, cx } = Card_styles(null, { name: "Card", unstyled });
  const _children = react.Children.toArray(children);
  const content = _children.map((child, index) => {
    if (typeof child === "object" && child && "type" in child && child.type === CardSection) {
      return (0,react.cloneElement)(child, {
        padding: p,
        "data-first": index === 0 || void 0,
        "data-last": index === _children.length - 1 || void 0
      });
    }
    return child;
  });
  return /* @__PURE__ */ react.createElement(CardProvider, {
    value: { padding: p }
  }, /* @__PURE__ */ react.createElement(Paper/* Paper */.X, Card_spreadValues({
    className: cx(classes.root, className),
    radius,
    p,
    ref
  }, others), content));
});
_Card.Section = CardSection;
_Card.displayName = "@mantine/core/Card";
const Card = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Card);


//# sourceMappingURL=Card.js.map


/***/ }),

/***/ 38623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.styles.js


const fade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  "from, to": { opacity: 0.4 },
  "50%": { opacity: 1 }
});
var useStyles = (0,create_styles/* createStyles */.k)((theme, { height, width, radius, circle, animate }) => ({
  root: {
    height,
    width: circle ? height : width,
    borderRadius: circle ? height : theme.fn.radius(radius),
    position: "relative",
    WebkitTransform: "translateZ(0)"
  },
  visible: {
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10
    },
    "&::after": {
      content: '""',
      position: "absolute",
      background: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      animation: animate ? `${fade} 1500ms linear infinite` : "none",
      zIndex: 11
    }
  }
}));

/* harmony default export */ var Skeleton_styles = (useStyles);

//# sourceMappingURL=Skeleton.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  height: "auto",
  width: "100%",
  visible: true,
  animate: true
};
const Skeleton = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Skeleton", defaultProps, props), { height, width, visible, animate, className, circle, radius, unstyled } = _a, others = __objRest(_a, ["height", "width", "visible", "animate", "className", "circle", "radius", "unstyled"]);
  const { classes, cx } = Skeleton_styles({ height, width, circle, radius, animate }, { unstyled, name: "Skeleton" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, { [classes.visible]: visible }, className),
    ref
  }, others));
});
Skeleton.displayName = "@mantine/core/Skeleton";


//# sourceMappingURL=Skeleton.js.map


/***/ }),

/***/ 82245:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/HeadOfPage.a6fc08d1.png","height":512,"width":4915,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAADFBMVEX////////////////1pQ5zAAAABHRSTlOdwKpcWyOAHwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABFJREFUCJljYGBkZGJkZGAGAAAqAAri7autAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 11775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useFetchNewsArticles; },
/* harmony export */   "G9": function() { return /* binding */ useFetchNewsArticle; },
/* harmony export */   "aC": function() { return /* binding */ useFetchNewsArticlesCount; },
/* harmony export */   "cW": function() { return /* binding */ DEFAULT_FETCHING_NEWS_OPTIONS; }
/* harmony export */ });
/* unused harmony exports fetchNewsArticle, fetchNewsArticles, fetchNewsArticlesCount */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40470);







var DEFAULT_STALE_TIME = 1000 * 60 * 30; // 30 min
var DEFAULT_FETCHING_NEWS_OPTIONS = {
    limit: 8,
    page: 1,
    condition: {
        ngon_ngu: "vi",
        loai_tin_tuc: [
            "Tin tức",
            "Tin tức Việt Thi\xean",
            "Tin tức c\xe0 ph\xea"
        ]
    }
};
var fetchNewsArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            shared: true,
                            condition: {
                                slug: slug
                            }
                        }
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticle(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticle = function(slug) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(slug), function() {
        return fetchNewsArticle(slug);
    }, {
        // staleTime: DEFAULT_STALE_TIME,
        enabled: !!slug
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            page: 1,
                            limit: 8,
                            sort: {
                                stt: 1,
                                date_created: -1
                            }
                        }, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                isnews: true,
                                ngon_ngu: "vi",
                                shared: true
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticles() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticles = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.list */ .w3.list(options), function() {
        return fetchNewsArticles(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(newsArticles) {
            newsArticles.map(function(newsArticle) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.slug), newsArticle);
            });
        }
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticlesCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, data, _args = arguments;
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: {
                            count: true,
                            condition: {
                                ngon_ngu: "vi",
                                isnews: true
                            }
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.rows_number) || 0);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticlesCount() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticlesCount = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.count */ .w3.count((options === null || options === void 0 ? void 0 : options.condition) || {}), function() {
        return fetchNewsArticlesCount(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 34964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95117);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);







var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .createStyles */ .k)(function() {
    return {
        imageWrapper: {
            width: "100%",
            aspectRatio: "1.65",
            position: "relative"
        }
    };
});
function NewCard(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = useStyles().classes;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    // const [hovered, setHovered] = React.useState(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Z, {
        shadow: "sm",
        p: 0,
        radius: "md",
        sx: {
            height: "100%",
            transition: "transform 0.3s ease",
            "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            scroll: false,
            href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                        visible: isLoading,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card.Section */ .Z.Section, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classes.imageWrapper,
                                children: !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                                        src: item === null || item === void 0 ? void 0 : item.picture,
                                        size: "s"
                                    }),
                                    alt: "Norway",
                                    layout: "fill",
                                    objectFit: "cover",
                                    loading: "lazy"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Group */ .Z, {
                        p: "md",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                visible: isLoading,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Title */ .D, {
                                        order: 2,
                                        style: {
                                            letterSpacing: 1
                                        },
                                        transform: "capitalize",
                                        size: "sm",
                                        lineClamp: 2,
                                        weight: "600",
                                        children: (item === null || item === void 0 ? void 0 : item.title) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Divider */ .i, {
                                        size: "xs",
                                        my: "sm",
                                        style: {
                                            background: "black"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                visible: isLoading,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .x, {
                                    size: "xs",
                                    children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NewCard);


/***/ }),

/***/ 99476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90698);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64523);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19236);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* eslint-disable jsx-a11y/anchor-is-valid */ 





function HomeTitle(param) {
    var children = param.children, _href = param.href, href = _href === void 0 ? "#" : _href;
    var isTablet = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().isTablet;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        sx: function(theme) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                margin: "70px 0 20px"
            }, theme.fn.smallerThan("md"), {
                margin: "30px 15px"
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Title */ .D, {
                    className: "webview",
                    order: 2,
                    size: isTablet ? "24px" : "36px",
                    align: "center",
                    w: "100#",
                    sx: function(theme) {
                        return {
                            transition: "0.3s",
                            color: "#12854F",
                            // color: theme.colors.second[3],
                            "&:hover": {
                                color: theme.colors.second[3]
                            }
                        };
                    },
                    children: children
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HomeTitle);


/***/ }),

/***/ 95197:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* eslint-disable jsx-a11y/anchor-is-valid */ 




function TitleCus(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Box, {
        sx: function(theme) {
            return _define_property({
                margin: "70px 0 20px"
            }, theme.fn.smallerThan("md"), {
                margin: "30px 15px"
            });
        },
        children: /*#__PURE__*/ _jsx(Title, {
            order: 2,
            size: "h2",
            align: "center",
            w: "100#",
            sx: function(theme) {
                return {
                    transition: "0.3s",
                    color: theme.colors.second[3],
                    "&:hover": {
                        color: theme.colors.second[3]
                    }
                };
            },
            children: children
        })
    });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TitleCus)));


/***/ }),

/***/ 51623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59926);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);







function DefaultSEO(param) {
    var seo = param.seo;
    // console.log(445555, seo)
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    if (!seo || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(seo)) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture1,
                size: "xl"
            }),
            width: 1200,
            height: 630,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    } else if (seo.picture2) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture2,
                size: "xl"
            }),
            width: 1200,
            height: 1200,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        openGraph: {
            url: "https://vietthien.com",
            title: seo.title,
            description: seo.description,
            images: images,
            locale: locale,
            type: seo.type || "website",
            siteName: "Việt Thi\xean",
            article: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (seo === null || seo === void 0 ? void 0 : seo.article) || {})
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 85654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomeNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apis_queryFunctions_news__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11775);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62679);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _Layout_Container_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6559);
/* harmony import */ var _NewCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34964);
/* harmony import */ var _Typography_HomeTitle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99476);
/* eslint-disable react/no-array-index-key */ /* eslint-disable no-underscore-dangle */ 










function HomeNews() {
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var ref = (0,_apis_queryFunctions_news__WEBPACK_IMPORTED_MODULE_1__/* .useFetchNewsArticles */ .AB)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _apis_queryFunctions_news__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_FETCHING_NEWS_OPTIONS */ .cW), {
        condition: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _apis_queryFunctions_news__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_FETCHING_NEWS_OPTIONS.condition */ .cW.condition), {
            ngon_ngu: locale
        })
    })), news = ref.data;
    // console.log('new', news)
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            size: "xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_HomeTitle__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        href: "/tin-tuc",
                        children: trans.homeNews.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .r, {
                        children: news ? news.slice(0, 4).map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                                xs: 12,
                                sm: 6,
                                lg: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NewCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    item: item
                                })
                            }, item._id);
                        }) : Array(4).fill(undefined).map(function(item, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                                xs: 12,
                                sm: 6,
                                lg: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NewCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    item: item,
                                    isLoading: true
                                })
                            }, i);
                        })
                    })
                ]
            })
        })
    });
}; // const HomeNews = () => {
 // };
 // export default HomeNews;


/***/ }),

/***/ 41291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72445);





function PageContainer(_param) {
    var children = _param.children, style = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: "lg"
    }, style), {
        children: children
    }));
};


/***/ }),

/***/ 60959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ sanitizeDOMData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);





var parseOptions = {
    replace: function(param) {
        var attribs = param.attribs, children = param.children;
        if (!attribs) {
            return;
        }
        if (attribs.dir === "ltr") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(children)
            });
        }
    }
};
function sanitizeDOMData(htmlString) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: parseOptions.replace
    };
    var cleanString = isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(htmlString, {
        USE_PROFILES: {
            html: true
        }
    });
    var html = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(cleanString, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        trim: true
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "webview",
        children: html
    });
};


/***/ })

}]);